import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Container from 'admin-components/components/Container';
import { colours } from 'themes/default';

const StyledContainer = styled(Container)`
  ${({ innerBorder, innerBorderWidth, innerBorderColor }) => {
    if (innerBorder === 'vertical' || innerBorder === true) {
      return css`
        :not(:first-child) {
          border-left: ${innerBorderWidth}px solid ${innerBorderColor || colours.Shades.TintBlue10};
        }
        height: 100%;
      `;
    }

    return css`
      height: 100%;
    `;
  }};
`;

const Cell = ({ children, innerBorderColor, innerBorderWidth = 1, id }) => (
  <StyledContainer
    orientation="vertical"
    verticalAlignment="center"
    horizontalAlignment="center"
    innerBorderColor={innerBorderColor}
    innerBorderWidth={innerBorderWidth}
    id={id}
  >
    {children}
  </StyledContainer>
);

Cell.propTypes = {
  children: PropTypes.node.isRequired,
  innerBorderWidth: PropTypes.number,
  innerBorderColor: PropTypes.string,
  id: PropTypes.string
};

export default Cell;
